module.exports = __webpack_public_path__ + "static/media/balKa_ipn17.331fa8a2.jpg";